import { useNavigate } from "react-router-dom";

import { useAuth } from "../../hooks";
import styles from "./LogoutButton.module.scss";

export function LogoutButton({ variant = "text" }) {
  const navigate = useNavigate();
  const { logout } = useAuth();

  function handleLogout() {
    logout();

    navigate("/login", {
      replace: true,
    });
  }

  if (variant === "icon") {
    return (
      <button
        type="button"
        className={styles.logoutIconButton}
        onClick={handleLogout}
        aria-label="Cerrar sesión"
        title="Cerrar sesión"
      >
        ⏻
      </button>
    );
  }

  return (
    <button
      type="button"
      className={styles.logoutButton}
      onClick={handleLogout}
    >
      Cerrar sesión
    </button>
  );
}